<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import Icon from 'dashboard/components-next/icon/Icon.vue';

// Sprint #46: badge na lista de conversas indicando BmtBotSession :active.
// Le do mesmo store (polling 5s) usado pelo BotActiveBanner.
const props = defineProps({
  conversationId: { type: [Number, String], required: true },
});

const byConversationId = useMapGetter('bmtBotActivity/byConversationId');
const session = computed(() => byConversationId.value?.[props.conversationId]);

const isBotActive = computed(() => !!session.value);
const botColor = computed(() => session.value?.bot_color || '#8B5CF6');
const botName = computed(() => session.value?.bot_name || 'Bot');
</script>

<template>
  <span
    v-if="isBotActive"
    v-tooltip.top="`Em atendimento pelo agente ${botName}`"
    class="inline-flex items-center justify-center rounded-full shrink-0 size-4"
    :style="{ backgroundColor: botColor }"
  >
    <Icon icon="i-lucide-bot" class="text-white size-3" />
  </span>
</template>
